export const validatePhoneLandline = (value, field) => {
  const phonePattern = /^(\+)?[0-9]*$/;

  if (!phonePattern.test(value)) {
    const errorProperty =
      value.includes("+") && value.lastIndexOf("+") > 0
        ? "invalidFormatError"
        : "invalidCharacterError";

    return errorProperty;
  }

  return "";
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

export const validateNumberField = (value) => {
  return /^[0-9]+$/.test(value);
};

export const isArrayString = (str) => {
  try {
    const parsedArray = JSON.parse(str);
    return Array.isArray(parsedArray);
  } catch (error) {
    return false;
  }
};
